module.exports = __webpack_public_path__ + "img/gamban-greyscale.8cac6953.svg";